module.exports = __webpack_public_path__ + "images/fa-b2b-img2.png";